import { useSelector } from "react-redux";
import { getProfile } from "../reducer/profileSlice";
import { getIAAM } from "../reducer/iaamSlice";
import { Suspense, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, CssBaseline, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import dotenv from 'react-dotenv';

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        // marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);

function Homepage(props) {
    const navigate = useNavigate();
    const profile = useSelector(getProfile);
    const iaam = useSelector(getIAAM);

    useEffect(() => {
        // console.log(`iaam : ${iaam}`);
        // console.log(`profile : ${profile}`);
        // console.log("Profile");
        // console.log(profile);
        if (profile !== undefined) {
            if (profile.error === "access denied") {
                iaam.login();
            } else {
                if (profile.userApproved === undefined) {
                    window.location.href = dotenv.IAAM_HOST;
                } else if (profile.userApproved === "true" || profile.userApproved === true) {
                    navigate('/loading');
                } else {
                    navigate("/permission");
                }
            }
        }
    }, [iaam, profile])

    return (
        <Box sx={{ display: 'flex', overflow: 'hidden', height: '100vh' }}>
            <CssBaseline />
            <Main className='p-0 mt-[60px] overflow-auto'>
                <Suspense>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                    }}>
                        
                        <img style={{
                            height: '200px',
                            marginBottom: '10px'
                        }} src="/images/Watch-Logo-Color.png"/>
                        <Typography
                            as="a"
                            href="#"
                            className="mr-4 ml-2 cursor-pointer py-1.5 text-black font-bold font-primary tracking-wide text-xl"
                        >
                            ยินดีต้อนรับเข้าสู่ ทันระบาด<span className="text-blue-600">ติดตาม</span>
                        </Typography>
                    </div>
                </Suspense>
            </Main>
        </Box>
    )
}

export default Homepage
